/**
 * Aucor Dropdown.js
 * -------------------
 *
 * Features:
 * - only adds classes, no show() or hide()
 * - timer for hover exit: better usability
 * - works with tabs: a11y
 * - desktop menu with touch: doubletap
 * - mobile menu with touch
 * - works at least with 3 levels (probably more)
 *
 */
aucor_dropdown = function( menu, options ) {

  if (!menu) {
    return this;
  }

  var extend = function ( defaults, options ) {
    var extended = {};
    var prop;
    for (prop in defaults) {
        if (Object.prototype.hasOwnProperty.call(defaults, prop)) {
            extended[prop] = defaults[prop];
        }
    }
    for (prop in options) {
        if (Object.prototype.hasOwnProperty.call(options, prop)) {
            extended[prop] = options[prop];
        }
    }
    return extended;
  };

  // Default settings
  var defaults = {
    desktop_min_width: 501,
  };

  var settings = extend( defaults, options ),
      desktop_min_width = settings.desktop_min_width, // match this to $menu-visible SASS variable
      screen_w,
      hover_timer,
      focus_timer;

  /**
   * Is desktop menu
   *
   * Checks if window is wider than set desktop limit.
   *
   * @return bool is desktop width screen
   */
  function is_desktop_menu() {

    screen_w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    if(screen_w < desktop_min_width) {
      return false;
    }
    return true;

  }

  /**
   * Hover timer (only for desktop menus)
   *
   * Keeps sub-menu open for a small time when hover has left the element.
   */
  var open_sub_menu = function(e) {

    if(!menu.classList.contains('menu-dropdown--clicked') && is_desktop_menu()) {

      var open = document.querySelectorAll('.menu-dropdown--open');
        if(open) {
          for(var i = 0; i < open.length; i++) {
            open[i].classList.remove('menu-dropdown--open');
            open[i].classList.remove('menu-dropdown--clicked');
          }
      }

      menu.classList.add('menu-dropdown--open');

      // clear timer
      clearTimeout(hover_timer);

    }


  };

  /**
   * Close menu when hover timer has ended (only for desktop menus)
   *
   * Triggers when mouse leaves menu element.
   */
  var close_sub_menu = function(e) {
    var t = this;
    // create timeout that let's the cursor get outside of menu for a moment
    if(is_desktop_menu()) {
      hover_timer = setTimeout( function() {
        if(!menu.classList.contains('menu-dropdown--clicked')) {
          document.querySelector('.menu-dropdown--open').classList.add('menu-dropdown--closing');
          menu.classList.remove('menu-dropdown--open');
          menu.classList.remove('menu-dropdown--clicked');
          setTimeout(function() {
            document.querySelector('.menu-dropdown--closing').classList.remove('menu-dropdown--closing');
          }, 200);
        }
      }, 750 );
    }
  };

  var open_submenu_with_click = function(e) {
    var open;
    if(menu.classList.contains('menu-dropdown--open') && menu.classList.contains('menu-dropdown--clicked')) {

        open = document.querySelectorAll('.menu-dropdown--open');
        if(open) {
          for(var i = 0; i < open.length; i++) {
            open[i].classList.remove('menu-dropdown--open');
            open[i].classList.remove('menu-dropdown--clicked');
          }
        }

    } else {
      open = document.querySelectorAll('.menu-dropdown--open');
      if(open) {
        for(var i = 0; i < open.length; i++) {
          open[i].classList.remove('menu-dropdown--open');
          open[i].classList.remove('menu-dropdown--clicked');
        }
      }
      menu.classList.add('menu-dropdown--open');
      menu.classList.add('menu-dropdown--clicked');
    }

    // don't trigger parent(s)
    e.stopPropagation();
  };

   menu.addEventListener('mouseenter', open_sub_menu);
   menu.addEventListener('mouseleave', close_sub_menu);


  var button = menu.querySelectorAll('.menu-dropdown__button');
  for(var i = 0; i < button.length; i++) {
    button[i].addEventListener('click', open_submenu_with_click);
  }

  // make the call chainable
  return this;
};
